// extracted by mini-css-extract-plugin
module.exports = {"buttonIgnore":"styles_buttonIgnore__uMP1U","buttonComplete":"styles_buttonComplete__OTNbR","text":"styles_text__2mzNF"};